﻿import { ajaxPost } from '../../utils/ajax';
import { mapGetters, mapState } from 'vuex';
import { required, minLength, numeric } from 'vuelidate/lib/validators'

export default {
    name: 'porting',

    template: '#porting-template',
    created() {
        document.getElementById("digitalvalidation-next").style.visibility = "visible";
    },
    mounted() {

        //this.$watch('$v.model.$invalid',
        //    () => {
        //        this.updateValidState();
        //    });
        //this.$watch('$v.partialmodel.$invalid',
        //    () => {
        //        this.updatePartialValidState();
        //    });
        //this.updateValidState();
        //this.updatePartialValidState();
        this.model = this.viewmodel;
        this.partialmodel = this.viewmodel;
        // if (this.model.clientRefresh) {
        //     this.$v.model.$touch();
        // }
        // if (this.model.existingAddress.clientRefresh) {
        //    this.$v.model.ExistingAddress.$touch();
        // }
        this.$store.watch(state => state.digitalvalidation.pageLoader.showLoader,
            (newState) => {
                this.showLoader = newState;
            });
        this.$store.watch(state => state.digitalvalidation.contracts.simSaved,
            (newState) => {
                this.simSaved = newState;
            });

        this.$store.watch(state => state.digitalvalidation.alertModal.show,
            (newState) => {
                if (newState === true) {
                    this.showPopUp = true;
                    this.$store.dispatch('hideModal');
                }
            });
        this.$store.watch(state => state.digitalvalidation.contracts.signedPortings,
            (signedPortings) => {
                if (signedPortings !== null) {
                    for (var i = 0; i < signedPortings.length; i++) {
                        if (signedPortings[i].AlreadySigned) {
                            document.getElementById('epoa' + i).disabled = true;
                            document.getElementById('checked' + i).disabled = true;
                        } else {
                            document.getElementById('checked' + i).checked = false;
                        }
                    }
                }
            });
    },
    props: ['blockid', 'viewmodel'],
    computed: {
        disableCheckAll: function() {
            for (var i = 0; i < this.model.epoaPortings.length; i++) {
                var check = this.$v.model.epoaPortings.$each[i].donorSim.$invalid;
                if (check === true) return true;
            }
            return false;
        }
    },
    data: () => ({
        model: {
            epoaPortings: [],
            notEpoaPortings: [],
            dealerCode: '',
            channelType: '',
            allValid: false
        },
        partialmodel: {
            epoaPortings: [],
            notEpoaPortings: []
        },
        showLoader: false,
        showPopUp: false,
        simSaved: true,        
        currentPopUpMessage: 'current popup message',
        allApproved: false,
    }),
    validations: {
        model: {
            epoaPortings: {
                $each: {
                    donorSim: {
                        required,
                        numeric,
                        hasRightLenght (value) {
                            if (value.length == 11 || value.length == 19 || value.length == 20)
                                return true;
                            return false;
                        }
                    },
                    isSigned: {
                        isChecked (value) {
                            if (value === true)
                                return true;
                            return false;
                        }
                    }

                }
            },
            notEpoaPortings: {
                $each: {
                    donorSim: {
                        required,
                        numeric,
                        hasRightLenght (value) {
                            if (value.length == 11 || value.length == 19 || value.length == 20)
                                return true;
                            return false;
                        }
                    }
                }
        }
    },
    partialmodel: {
            epoaPortings: {
                $each: {
                        donorSim: {
                            numeric,
                            hasRightLenght (value) {
                                if (value.length == 0 || value.length == 11 || value.length == 19  || value.length == 20)
                                    return true;
                                return false;
                            }
                        }
                }
            },
        notEpoaPortings: {
                $each: {
                    donorSim: {
                        numeric,
                        hasRightLenght (value) {
                            if (value.length == 0 || value.length == 11 || value.length == 19 ||  value.length == 20)
                                return true;
                            return false;
                        }
                    }
                }
        }
    }

},    
methods: { 
    
    signPortings: function(event, portings, loaderTitle, loaderMessage, popupMessage) {
            event.preventDefault();
       
            this.$store.dispatch('signPortings', {'portingDigitalValidationViewModel': portings,'loaderTitle':loaderTitle, 'loaderMessage':loaderMessage, 'popupMessage': popupMessage});
        },
    getTeliaContracts: function(event, orderId, documentId, dealerCode, channelType, fileName, loaderTitle, loaderMessage, popupMessage) {
            event.preventDefault();
            this.$store.dispatch('getDivaContracts', {'orderId': orderId, 'documentId': documentId, 'dealerCode': dealerCode, 'channelType': channelType, 'fileName' : fileName,'loaderTitle':loaderTitle, 'loaderMessage':loaderMessage, 'popupMessage': popupMessage });
        },
    updatePortingDetails (porting, dealerCode, orderId, invalid, loaderTitle, loaderMessage, popupMessage) {               
        if (!invalid) {
            porting.donorSimOldValue = porting.donorSim;
            porting.isSigned = false;
            this.$store.dispatch('updatePortingDetails', {'porting': porting, 'dealerCode': dealerCode, 'orderId': orderId, 'localNumber': porting.telephoneNumber , 'simNumber': porting.donorSim,'loaderTitle':loaderTitle, 'loaderMessage':loaderMessage, 'popupMessage': popupMessage});
        }
    },
        closePopup: function (refresh) {        
            this.showPopUp = false;            
            if (refresh === true) {
                window.location.reload();
            }
        },
    invalidate(porting, validity,value, oldValue) {        
        if (validity.$invalid === false && (value === oldValue)) {
            this.simSaved = true;
        } else {
            if (this.simSaved === true) {
                this.simSaved = false;
                porting.isSaved = false;
            }
        }
    },
    checkboxClicked(event) {        

        var checked = event.target.checked;
        for (var i = 0; i < this.model.epoaPortings.length; i++) {
            checked = checked && this.model.epoaPortings[i].isSigned;
        }
        this.allApproved = checked;
    },
    approveAllDocuments(event) {
        if (event.target.checked) {
            this.model.epoaPortings.forEach(function(porting) {
                porting.isSigned = true;
            });
            this.allApproved = true;
        } else {
            this.model.epoaPortings.forEach(function(porting) {
                porting.isSigned = false;
            });
            this.allApproved = false;
        }
    },
    goBack() {
        document.getElementById("digitalvalidation-form").submit(); 
    },
    updateValidState() {
        this.$store.dispatch('updateValidState', {invalid: this.$v.model.$invalid, blockId: this.blockid});              
    },
    updatePartialValidState() {
        this.$store.dispatch('updatePartialValidState', {invalid: this.$v.partialmodel.$invalid, blockId: this.blockid});              
    }
},
ready: function() { 
}
}